import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { OwnerModelFormDTO, OWNERTYPE_MAP } from '../../../../OtherAssets.meta';

interface Props {
  ownerModelFields: OwnerModelFormDTO[];
}

export const TotalSummary = ({ ownerModelFields }: Props) => {
  const totalPercentage =
    ownerModelFields
      .filter(owner => owner.Name && owner.Percentage)
      .reduce((acc, owner) => +(owner.Percentage || 0) + acc, 0) || 0;

  return (
    <>
      <Box px="8" display="flex" justifyContent="end" css="gap: 16px">
        <Text fontSize="body" fontWeight={600}>
          Total Ownership:
        </Text>
        <Text
          fontSize="body"
          fontWeight={600}
          color={totalPercentage === 100 ? 'success.600' : 'neutral.600'}
        >
          {totalPercentage}%
        </Text>
      </Box>

      <Card p="8">
        <Text fontSize="body" fontWeight={600}>
          Ownership Summary:
        </Text>

        {ownerModelFields
          .filter(b => b.Name && b.Percentage)
          .map(({ Name, OwnerType, Percentage }) => (
            <Box key={Name} display="flex" justifyContent="space-between" alignItems="center">
              {OwnerType !== undefined && (
                <Text fontSize="body">
                  {Name} ({OWNERTYPE_MAP[OwnerType]})
                </Text>
              )}
              <Text fontSize="body">{Percentage}%</Text>
            </Box>
          ))}
      </Card>
    </>
  );
};
